import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import './DropDownColor.scss';

import { ReactComponent as ColorPicker } from "static/icons/color-picker.svg";

import { colors } from "../../../utils/data";


const DropDownColor = ({ submitClick, color }) => {
  const { t } = useTranslation();

  const defaultLabel = t('blue');
  const customColor = t('custom_color');

  const [infoDropDown, setInfoDropDown] = useState({ label: defaultLabel, color: color, active: false });

  useEffect(() => {
    const baseColor = colors.filter((baseColor) => baseColor.hex === color);

    if (baseColor.length) {
      setInfoDropDown({ ...infoDropDown, label: baseColor[0].name });
    } else {
      setInfoDropDown({ ...infoDropDown, label: customColor });
    }
  }, []);

  const handleClick = (el) => () => {

    setInfoDropDown({ label: el.name, color: el.hex, active: false });

    if (submitClick) {
      submitClick({ color: el.hex });
    }
  };

  const handleClickColorPicker = (event) => {
    const color = event.target.value;

    setInfoDropDown({ label: customColor, color: color, active: false });

    if (submitClick) {
      submitClick({ color: color });
    }
  };

  const handleSwitch = () => {
    setInfoDropDown({ ...infoDropDown, active: !infoDropDown.active });
  };

  const condition = infoDropDown.active ? "active-drop" : "";

  return (
    <div className="drop-down-color">
      <label className="drop-down-color__label">{t('color')}</label>
      <div className="drop-down-color__wrapper">
        <div className={`drop-down-color__btn ${infoDropDown.active ? "active__btn" : ""}`} onClick={handleSwitch}>
          {t(infoDropDown.label)} <i className={`arrow-icon ${infoDropDown.active ? "active" : ""}`}></i>
        </div>
        <div className={`drop-down-color__box-wrapper ${condition}`}>
          <div className="drop-down-color__box">
            <label className="drop-down-color__item-custom" htmlFor="choose-color" >
              <div className="drop-down-color__img-custom"><ColorPicker /></div>
              <p key="dropdown-custom-color">{t('custom_color')}...</p>
            </label >
            <div className="drop-down-color__line"></div>
            {
              colors.map((color) => (
                <div className="drop-down-color__item" onClick={handleClick(color)} key={color.name}>
                  <div className="drop-down-color__example" style={{ backgroundColor: color.hex }}></div>
                  <p key={"dropdown" + color.name}>{t(color.name)}</p>
                </div>
              ))}
          </div>
        </div>
        <input id="choose-color" type="color"
          value={infoDropDown.color}
          style={{ backgroundColor: infoDropDown.color }}
          onChange={(event) => handleClickColorPicker(event)} />
      </div>
    </div>
  );
};

export default DropDownColor;